export const file_edit = () => (
  <path
    d="M13 2H5a2 2 0 00-2 2v16a2 2 0 002 2h4m4-20l6 6m-6-6v6h6m0 2V8m-1.5 5.5a2.121 2.121 0 013 3L15 22h-3v-3l5.5-5.5z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
